import { useGame } from "./GameContext";
import HintContainer from "./HintContainer";
import "./header.css";

export default function Header({ backgroundNone0 = false }) {
  const {
    backgroundNone,
    time,

    /* 🔥 변경 포인트 */
    clearedStages, // ⬅️ missionCount 대신
    missionTotal,

    openHint,
    hintView,
    closeHint,
  } = useGame();

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  /* 배경 우선순위
     1. 컴포넌트에서 받은 backgroundNone0 === true
     2. Context backgroundNone === true
  */
  const backgroundNoneVal =
    backgroundNone0 === true ? true : backgroundNone === true;

  const handleBack = (e) => {
    e.preventDefault();

    if (hintView === "DETAIL") {
      openHint(); // DETAIL → LIST
      return;
    }

    if (hintView === "LIST") {
      closeHint(); // LIST → 닫기
      return;
    }

    window.history.back();
  };

  return (
    <>
      <div
        id="box_hd"
        style={backgroundNoneVal ? { background: "none" } : undefined}
      >
        {/* 뒤로가기 */}
        <div className="box_hd_d">
          <a href="#" className="box_hd_back_arr" onClick={handleBack} />
        </div>

        <div className="box_hd_rt">
          {/* 타이머 */}
          <div className="box_hd_d box_hd_timer mr8 box_icon1">
            <label className="box_hd_tit">
              {minutes}:{seconds < 10 ? "0" : ""}
              {seconds}
            </label>
          </div>

          {/* 🔥 힌트 / 진행 카운트 */}
          <div className="box_hd_d box_hd_quizCnt" onClick={openHint}>
            <label className="box_hd_tit">
              {clearedStages.size}/{missionTotal}
            </label>
          </div>
        </div>
      </div>

      {/* 힌트 컨테이너 */}
      <HintContainer />
    </>
  );
}
